import { render } from "./PropertiesListing.vue?vue&type=template&id=50596119&scoped=true&ts=true"
import script from "./PropertiesListing.vue?vue&type=script&lang=ts"
export * from "./PropertiesListing.vue?vue&type=script&lang=ts"

import "./PropertiesListing.vue?vue&type=style&index=0&id=50596119&scoped=true&lang=css"
import "./PropertiesListing.vue?vue&type=style&index=1&id=50596119&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50596119"]])

export default __exports__